import { Component, OnInit } from '@angular/core';
import { ConfigLoaderService } from '../../Shared/Services/Config/config-loader.service';
import { getLocaleDateFormat } from '@angular/common';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { SpooldownloadModalComponent } from '../../Shared/Components/spooldownload-modal/spooldownload-modal.component';
import { SpoolDownloadService } from '../../Shared/Services/SpoolDownload/spooldownload.service';
import { Subscription } from 'rxjs';
//import { BroadcastService, MsalService } from '@azure/msal-angular';
import { AuthService } from '../../Shared/Services/auth.service'
import { AdminComponent } from '../admin/admin.component';
import { UserService } from '../../Shared/Services/user.service'
import { DocketUploadComponent } from '../docket-upload/docket-upload.component'
import { ProjectPermissionComponent } from '../project-permission/project-permission.component';
import {userRole} from '../../Shared/Model/enum';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  modalRef!: MDBModalRef;
  UserName!: string;
  environment!: string;
  CompanyTitle!: string;
  name!: string;
  subscription!: Subscription;

  UserRole!: string;
  UserDownloadAccess: boolean = false;
  showAdmin: boolean = false;


  showDocketUpload: boolean = false;

  showPortalUI:boolean=false;


  constructor(
    private modalService: MDBModalService,
    private _configLoaderService: ConfigLoaderService,
   // private broadcastService: BroadcastService,
   // private msalService: MsalService,
    private authservice: AuthService,
    private _spoolDownloadService: SpoolDownloadService,
    private _userService: UserService
  ) {


  }



  ngOnInit(): void {

    console.log(ConfigLoaderService.settings.AppSettings.IsOfflineLogged)
    if (ConfigLoaderService.settings.env.name == "DEVELOPMENT") {
      this.UserName = ConfigLoaderService.settings.DevValues.userName;
    }
    else {
      this.UserName = ConfigLoaderService.settings.AppSettings.userId;
      if(ConfigLoaderService.settings.AppSettings.IsOfflineLogged){
        this.showPortalUI=false
      }
      else{
        this.showPortalUI=true
      }
      // this.broadcastService.subscribe('msal:acquireTokenSuccess', (payload) => {

      // });
      // this.broadcastService.subscribe('msal:acquireTokenFailure', (payload) => {

      //   console.log('access token acquisition fails');
      // })

      // const account = this.getAccount();
      // this.UserName = account.userName.split('@')[0];
      // ConfigLoaderService.settings.AppSettings.userId = this.UserName;
      this.loadText();
      this.getUserDownloadAccess(this.UserName);
      this.getUserRole(this.UserName);
     // this.getDocketAccess(this.UserName);


    }
  }

  getUserRole(userId: string) {

   
   
    let sesStorage!: any;
    sesStorage = sessionStorage.getItem("sessionStorage")?.toString();
    this._userService.getUserRole(userId, sesStorage).subscribe(
      data => {

        var jsonData = JSON.stringify(data);
        const valueFromJson = JSON.parse(jsonData);
        let keys = Object.keys(valueFromJson);
        Object.getOwnPropertyNames(valueFromJson).forEach(key => {

          if (key == "Role") {
            this.UserRole = valueFromJson[key];
            //this.UserRole="ADMIN";
            //console.log(this.UserRole)
          }
        });
        console.log(this.UserRole.toUpperCase())
        if (this.UserRole.toUpperCase() == userRole.Admin) {

          this.showAdmin = true;
          this.showDocketUpload = true;
        }
        else if (this.UserRole.toUpperCase() == userRole.BA){
          this.showDocketUpload = true;
         
        }
      

      })
    // this.UserRole = ConfigLoaderService.settings.DevValues.UserRole;

    // if (this.UserRole.toUpperCase() == "ADMIN") {

    //   this.showAdmin = true;
    // }
    // else





  }

  getUserDownloadAccess(userId: string) {

    this._spoolDownloadService.getUserDownloadAccess(userId)
      .subscribe(
        data => {

          if (data == 'Y') {
            this.UserDownloadAccess = true;
          }
          else {
            this.UserDownloadAccess = false;
          }
        },
        error => {
        }

      )

  }

  // getDocketAccess(userName: string) {
  //   if (ConfigLoaderService.settings.DevValues.DocketUploadAccess.toUpperCase() == "TRUE") {
  //     this.showDocketUpload = true;
  //   }
  //   else{
  //     this.showDocketUpload = false;
  //   }
  // }

  // getAccount() {
  //   return this.msalService.getAccount();

  // }


  LoadAdmin() {

    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,

    }
    this.modalRef = this.modalService.show(AdminComponent, modalOptions)
    // this.modalRef = this.modalService.show(NotificationComponent,modalOptions)
  }

  spoolDownload() {
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,

    }
    this.modalRef = this.modalService.show(SpooldownloadModalComponent, modalOptions)
  }

  LoadDocketUpload() {
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,

    }
    this.modalRef = this.modalService.show(DocketUploadComponent, modalOptions)

  }

  LoadProjectPermission(){
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,

    }
    this.modalRef = this.modalService.show(ProjectPermissionComponent, modalOptions)
  }
  loadText() {
    this.CompanyTitle = "Accenture System Diagnostics";
  }

  logOut() {
    this.authservice.logout();
  }

}
